import _ from 'lodash';

/**
 * Returns a function that checks if current component row data are the same as the original data state by comparing indecies that match the provided key
 * @param key Component state stored intermediate calc
 * @returns Function
 */
export const isOrderSameByFactory = <T extends Object>(
  key: keyof T,
): ((rows: T[], configs: T[]) => boolean) => {
  const isOrderSame = (rows: T[], configs: T[]): boolean =>
    _.every(rows, (row, rowIndex) => {
      const configIndex = _.findIndex(
        configs,
        (config) => config[key] === row[key],
      );
      return rowIndex === configIndex;
    });
  return isOrderSame;
};
